export const removeUsers = (state, payload) => {
  const validUserIds = new Set(
    payload
      .filter((sub) => sub.status === 'success')
      .map((sub) => sub.old_user_id),
  )

  return state.filter((user) => !validUserIds.has(user.id))
}

export const replaceUsers = (state, payload) => {
  const userMap = new Map(state.map((user) => [user.id, user]))
  const replacedMap = new Map()

  payload.forEach(
    ({ new_user_id: newUserId, old_user_id: oldUserId, status }) => {
      if (status !== 'success') return

      const newUser = userMap.get(newUserId)
      const oldUser = userMap.get(oldUserId)

      if (newUser && oldUser) {
        replacedMap.set(newUserId, {
          ...oldUser,
          id: newUser.id,
          email: newUser.email,
        })
        replacedMap.set(oldUserId, {
          ...newUser,
          id: oldUser.id,
          email: oldUser.email,
        })
      }
    },
  )

  return state.map((user) => replacedMap.get(user.id) || user)
}

export const subscribeUsers = (state, payload) => {
  const subscriptionMap = new Map(
    payload
      .filter((sub) => sub.status === 'success')
      .map((sub) => [
        sub.new_user_id,
        {
          plan_code: sub.new_plan_code,
          plan_interval: sub.plan_interval,
          status: 'active',
          tier: sub.tier,
        },
      ]),
  )

  return state.map((user) => {
    const subscription = subscriptionMap.get(user.id)
    if (subscription) {
      return { ...user, tier: subscription.tier, subscription }
    }
    return user
  })
}

export const unsubscribeUsers = (state, payload) => {
  const unsubscribedIds = new Set(
    payload
      .filter((sub) => sub.status === 'success')
      .map((sub) => sub.old_user_id),
  )

  return state.map((user) => {
    if (unsubscribedIds.has(user.id)) {
      const { subscription: _, ...rest } = user
      return { ...rest, tier: 'free' }
    }
    return user
  })
}

export const replaceUserSubscription = (state, payload) => {
  const subscriptionMap = new Map(
    payload
      .filter((sub) => sub.status === 'success')
      .map((sub) => [
        sub.old_user_id,
        {
          plan_code: sub.new_plan_code,
          plan_interval: sub.plan_interval,
          status: 'active',
          tier: sub.tier,
        },
      ]),
  )

  return state.map((user) => {
    const subscription = subscriptionMap.get(user.id)
    if (subscription) {
      return { ...user, tier: subscription.tier, subscription }
    }
    return user
  })
}
